<template>
    <button class="btn" :class="{'selected' : isSelected}" @click="selectGroup">
        <span class="ellipsis">{{ group.title }}</span>
    </button>
</template>

<script>

export default {
    props: {
        group: Object,
        isSelected: Boolean
    },
    methods: {
        selectGroup() {
            this.$emit('selectGroup', this.group)
        }
    }
}
</script>
